var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name === 'login')?_c('router-view'):_c('mainFunc'),_vm._v(" "),_c('van-popup',{staticStyle:{"width":"100%"},model:{value:(_vm.showProcess),callback:function ($$v) {_vm.showProcess=$$v},expression:"showProcess"}},[_c('van-progress',{attrs:{"percentage":_vm.processText,"pivot-text":" "}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2f2296","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 